<template>
  <div class="part mt-4">
    <div class="header_style">
      <h2 class="h2_style mb-0">FPS</h2>
    </div>
    
    <div class="part__cnt">
      <div class="label_style mt-3">
        <ul
          v-for="item in FPSValue"
          :key="item.label"
          style="text-align: center"
        >
          <li
            v-if="
              item.label != 'FPS<=10[%]' && item.label != 'FPS>=25[%]'
            "
          >
            {{ item.label }}
          </li>
          <li
            v-else-if="item.label == 'FPS<=10[%]'"
            style="text-align: center; width: 100px"
          >
            <div style="display: flex">
              {{ lte }}

              <input
                @blur="lteclick(lteValue)"
                v-model="lteValue"
                style="
                  width: 60px;
                  box-sizing: border-box;
                  padding-left: 10px;
                  border-radius: 3px;
                  outline: none;
                  border: 1px solid #dcdfe6;
                "
              />

              <span>%</span>
            </div>
          </li>
          <li v-else-if="item.label == 'FPS>=25[%]'">
            <div style="display: flex">
              {{ gte }}

              <input
                @blur="gteclick(gteValue)"
                v-model="gteValue"
                style="
                  width: 60px;
                  box-sizing: border-box;
                  padding-left: 10px;
                  border-radius: 3px;
                  outline: none;
                  border: 1px solid #dcdfe6;
                "
              />

              <span>%</span>
            </div>
          </li>
          <li>{{ item.value || '-' }}</li>
        </ul>

        <ul v-for="item in fpsNewFieldsData" :key="item.label">
          <li>{{ item.label }}</li>
          <li>{{ item.value }}</li>
        </ul>
      </div>

      <div v-show="hasData(fpsDataFields)" class="position-relative">
        <div id="fps_line" style="width: 100%; height: 400px"></div>
        <label-list ref="labelList1" :perf_second_data="perf_second_data" chartKey="fps_line_chart" />
        <chart-rect ref="chartRect1" chartKey="fps_line_chart" />
      </div>

      <div v-show="frameData?.FrameTime?.length" class="position-relative">
        <div id="frametime_line" style="width: 100%; height: 400px"></div>
        <label-list ref="labelList2" :perf_second_data="perf_second_data" chartKey="frametime_line_chart" />
        <chart-rect ref="chartRect2" chartKey="frametime_line_chart" />
        <!-- <chart-rect :visibleRect="visibleRect" :rectLeft="rectLeft" :rectWidth="rectWidth" :startXValue="startXValue" :endXValue="endXValue" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as echarts from 'echarts'
import LabelList from '../label-list.vue'
import {allChart} from '../common.js'
import ChartRect from '../rect.vue'

const useFpsChart = {
  data() {
    return {
      seriesInfo: [
        {name: 'fps', dataKey: 'FPS'},
        {name: 'Jank', dataKey: 'Jank'},
        {name: 'BigJank', dataKey: 'BigJank'},
        {name: 'Stutter', dataKey: 'Stutter[%]'},
        {name: 'InterFrame', dataKey: 'InterFrame'},
      ]
    }
  },

  computed: {
    fpsDataFields() {
      return this.seriesInfo.map(item => item.dataKey)
    },
  },

  methods: {
    getFpsOption() {
      return {
        title: {
          text: "FPS",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
        },
        series: this.seriesInfo.map(item => {
          let result = {
            name: item.name,
            data: this.secondData?.[item.dataKey],
            type: "line",
            showSymbol: false,
            itemStyle: this.chartSettings.itemStyle2,
          }

          if (item.name == 'fps') {
            item.renderItem = (params, api) => {
              const xValue = api.value(0);
              const yValue = api.value(1);
              const point = api.coord([xValue, yValue]);
              return {
                type: "circle",
                shape: {
                  cx: point[0],
                  cy: point[1],
                  r: 5,
                },
                style: {
                  fill: "red",
                },
              };
            }
          }

          return result
        }),
      }
    },

    drawPieChartFPS() {
      let chartDom = document.getElementById("fps_line")
      if (!chartDom) return
      if (!allChart.fps_line_chart) {
        allChart.fps_line_chart = echarts.init(chartDom)
      }
      allChart.fps_line_chart.setOption(this.getFpsOption(), {notMerge: true})
    },
  }
}

const useFrameTimeChart = {
  computed: {
    frameData() {
      return this.perf_second_data?.['每帧数据']?.rows || {}
    },
  },

  methods: {
    getFrameOption() {
      return {
        title: {
          text: "Frame Time",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line", // 默认为直线，可选为：'line' | 'shadow'
          },
          className: 'echarts-tooltip',
          formatter: (params) => {
            {
              //  只粘贴formatter了

              let relVal = params[0].axisValueLabel.split("_")[0];

              for (let i = 0; i < params.length; i++) {
                relVal +=
                  "<div  style='display:flex;align-items:center;' ><div style='width:120px'>" +
                  params[i].marker +
                  params[i].seriesName +
                  '</div><div style="font-weight:bold">' +
                  (params[i].value == undefined ? "-" : params[i].value) + //   不同点
                  "</div></div>";
              }

              return relVal;
            }
          },
        },
        toolbox: this.chartSettings.toolbox,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          // data: this.frameData?.id_frame.map(
          //   (v, index) => v + "_" + String(index)
          // ),
          data: this.frameData?.id_frame,
        },
        series: [
          {
            name: "frame_time",
            type: "line",
            showSymbol: false,
            data: this.frameData?.FrameTime,
            itemStyle: this.chartSettings.itemStyle,
          },
        ],
      }
    },

    drawFrame() {
      let chartDom = document.getElementById("frametime_line")
      if (!chartDom) return
      if (!allChart.frametime_line_chart) allChart.frametime_line_chart = echarts.init(chartDom)
      allChart.frametime_line_chart.setOption(this.getFrameOption(), {notMerge: true})
    },
  }
}

const useDataZoom = { //缩放图表功能
  methods: {
    reDrawRect() {  //改变所有矩形选框的位置和宽度
      const startX = allChart.fps_line_chart.convertToPixel({xAxisIndex: 0}, this.rect.startXValue)
      const endX = allChart.fps_line_chart.convertToPixel({xAxisIndex: 0}, this.rect.endXValue)
      this.rect.rectLeft = startX
      this.rect.rectWidth = endX - startX
    },

    onZoom(chart) {
      if (!chart) return
      chart.on('datazoom', params => {
        const {dataZoom, xAxis} = chart.getOption(),
          startIndex = dataZoom[0].startValue,
          endIndex = dataZoom[0].endValue,
          startValue = xAxis[0].data[startIndex],
          endValue = xAxis[0].data[endIndex]

        this.saveZoomInfo({...params, startValue, endValue})
        this.updateCurLabels({startValue, endValue})
        this.reDrawRect()
      })
    },
  }
}

export default {
  mixins: [useFpsChart, useFrameTimeChart, useDataZoom],

  components: {LabelList, ChartRect},

  inject: ['getIdLabelParam', 'injectObj', 'updateCurLabels', 'rect', 'saveZoomInfo', 'hasData'],

  props: {
    testInfo3: Object,
    perf_second_data: Object,
    chartSettings: Object,
  },

  data() {
    return {
      lte: 'FPS<=',
      lteValue: "10",
      gte: "FPS>=",
      gteValue: "25",
      fpsNewFieldsData: [],
      ChangeFPS: {
        lteFPS: "-",
        gteFPS: "-",
      },
    }
  },

  computed: {
    isAllChecked() {
      return this.injectObj.isAllChecked
    },

    project() {
      return Number(this.$route.query.project)
    },

    FPSValue() {
      let data = this.testInfo3

      let result = [
        {
          label: "Avg(FPS)",
          value: data?.['Avg(FPS)'],
        },
        {
          label: "Var(FPS)",
          value: data?.['Var(FPS)'],
        },
        {
          label: "FPS<=10[%]",
          value: this.ChangeFPS?.lteFPS,
        },
        {
          label: "FPS>=25[%]",
          value: this.ChangeFPS?.gteFPS,
        },
        this.project === 71
          ? {
              label: "FPS>=50[%]",
              value:
                data?.["FPS>=50[%]"] ?? data?.["FPS>50[%]"] ?? "-",
            }
          : {
              label: "FPS>=18[%]",
              value: data?.['FPS>=18[%]'],
            },
        this.project === 71
          ? {
              label: "FPS>=55[%]",
              value:
                data?.["FPS>=55[%]"] ?? data?.["FPS>55[%]"] ?? "-",
            }
          : {
              label: "FPS>=40[%]",
              value: data?.fps_lt_40_pcnt,
            },
        {
          label: "Jank",
          value: data?.jank,
        },
        {
          label: "BigJank",
          value: data?.big_jank,
        },
        {
          label: "Stutter[%]",
          value: data?.['Stutter[%]'],
        },
        {
          label: "Avg(InterFrame)",
          value: data?.['Avg(InterFrame)'],
        },
        // {
        //   label: "GC次数[次]",
        //   value: this.testInfo?.gc_cnt,
        // },
        // {
        //   label: "GC频率[次/分]",
        //   value: this.testInfo?.gc_freq,
        // },
      ]

      return result
    },

    xData() {
      return this.secondData?.timeline || []
    },

    secondData() {
      return this.perf_second_data?.['每秒数据']?.rows || {}
    },
  },

  methods: {
    async init(isMounted) {
      this.getChangeFPS()
      this.initCharts(isMounted)
      await this.$nextTick()
      this.$refs.chartRect1?.init(isMounted)
      this.$refs.chartRect2?.init(isMounted)
    },

    initCharts(isMounted) {
      this.drawPieChartFPS()
      this.drawFrame()
      if (isMounted) {
        this.onZoom(allChart.fps_line_chart) //由于联动的存在，只需在一个图表中注册datazoom事件即可
        //this.onZoom(allChart.frametime_line_chart)
      }
    },
 
    lteclick() {
      //
    },

    gteclick() {
      //
    },

    async getFpsData(value, mode) {
      const {project, id_test} = this.$route.query
      const {data} = await axios('performance/fps_compute/', {
        params: {
          project,
          id_test,
          value,
          labels: this.getIdLabelParam(),
          mode,
        }
      })
      return data?.fps
    },

    async getChangeFPS() {
      const result = await Promise.all([this.getFpsData(this.lteValue, 'lte'), this.getFpsData(this.gteValue, 'gte')])
      this.ChangeFPS.lteFPS = result[0]
      this.ChangeFPS.gteFPS = result[1]
    },
  }
}
</script>

<style scoped>
@import "../common.css"
</style>
